export const SPLIT_VALUE = '=';
